// Modules
import { Button, Radio, RadioChangeEvent, Input, Checkbox } from "antd";
import { CheckboxChangeEvent } from "antd/es/checkbox";

// styles
import styles from "components/molecules/Filters/filters.module.css";

// Constants
import { Filters as Constants } from "constants/global";

export type FilterItem = {
	value: string;
	label?: string;
	id: string;
	type?: "search" | "default";
	hasInput?: boolean;
	inputPlaceholder?: string;
	filterName?: string;
};

type FilterProps = {
	filters: Array<{
		title: string;
		values: Array<FilterItem>;
	}>;
	selectedFilers: Array<string | undefined>;
	onClick: ({ value, name, checked, isTextInput }: { name: string; value: string; checked: boolean; isTextInput?: boolean }) => void;
	onReset: () => void;
	onGlobalStateChange?: (filterType: string, value: string) => void;
	filterInputs?: {
		receipt?: string;
		outlet?: string;
		outletName?: string;
		outletCode?: string;
	};
};

const Filters = ({ filters, selectedFilers, onClick, onReset, onGlobalStateChange, filterInputs }: FilterProps) => {
	const handleRadioChange = (e: RadioChangeEvent) => {
		onClick({
			value: e.target.value,
			name: e.target.name || "",
			checked: e.target.checked
		});
	};

	const handleCheckboxChange = (e: CheckboxChangeEvent, title: string) => {
		const value = e.target.value;
		const isChecked = e.target.checked;
		onClick({
			value,
			name: title,
			checked: isChecked
		});
	};

	const handleTextInputChange = (e: React.ChangeEvent<HTMLInputElement>, filterType: string) => {
		e.preventDefault();
		e.stopPropagation();

		onClick({
			value: e.target.value,
			name: filterType,
			checked: true,
			isTextInput: true
		});

		if (onGlobalStateChange) {
			onGlobalStateChange(filterType, e.target.value);
		}
	};

	return (
		<div className={styles?.root}>
			<div className={styles?.reset_wrapper}>
				<Button className={styles?.reset_button} onClick={onReset}>
					{Constants.RESET_BUTTON_LABEL}
				</Button>
			</div>
			<div className={styles?.filters_wrapper}>
				{filters?.map(({ title, values }, idx) => {
					const isFilterBySection = title === "Filter by";
					const isSortBySection = title === "Sort by";
					let selectedValue;

					if (isSortBySection) {
						// For "Sort by", check selectedFilers[1] which contains the sort value
						const sortValue = selectedFilers[1];
						if (sortValue) {
							selectedValue = sortValue;
						} else {
							// Default to first value if nothing is selected
							selectedValue = values.length > 0 ? values[0].value : undefined;
						}
					} else if (!isFilterBySection) {
						const len = values.length;
						for (let j = 0; j < len; j++) {
							if (selectedFilers.includes(values[j].value)) {
								selectedValue = values[j].value;
								break;
							}
						}
					}

					return (
						<div key={`${title}-${idx}`}>
							<div className={styles?.filter_header}>{title}</div>
							<div className={styles?.filter_items}>
								{isFilterBySection ? (
									<div>
										{values?.map((item, index) => {
											const isChecked = selectedFilers[0]?.split(",").includes(item.value);
											const inputValue = filterInputs?.[item.filterName as keyof typeof filterInputs] || "";

											return (
												<div className={styles?.filter_item_checkbox} key={`${item.value}-${index}`}>
													<Checkbox id={item?.id} value={item.value} onChange={(e) => handleCheckboxChange(e, title)} checked={isChecked}>
														<span className={styles?.item_label}>{item?.label || item?.value}</span>
													</Checkbox>
													{item.hasInput && (
														<Input
															placeholder={item.inputPlaceholder}
															value={inputValue}
															disabled={!isChecked}
															onChange={(e) => handleTextInputChange(e, item.filterName || "")}
															className={styles.filter_input}
															onClick={(e) => e.stopPropagation()}
														/>
													)}
												</div>
											);
										})}
									</div>
								) : (
									<Radio.Group name={title} onChange={handleRadioChange} value={selectedValue}>
										{values?.map((item, index) => {
											return (
												<div className={styles?.filter_item} key={`${item.value}-${index}`}>
													<Radio id={item?.id} value={item.value} className="filter_radio">
														<span className={styles?.item_label}>{item?.label || item?.value}</span>
													</Radio>
												</div>
											);
										})}
									</Radio.Group>
								)}
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default Filters;
